import axios from 'axios';

const path = 'PosDashboard';
const apiPath = '/pos/dashboard/get-statistic-data';

export const PosDashboardActions = {
   GET_DATA: `${path}/getData`,
};

export const PosDashboardAPIsConstants = {
   API_PATH: apiPath,
};

const PosDashboard = {
   namespaced: true,
   state: {
      loading: false,
      data: {},
   },
   mutations: {
      SET_LOADING(state, payload) {
         state.loading = payload;
      },
      SET_DATA(state, payload) {
         state.data = payload;
      },
   },
   actions: {
      getData({ commit }) {
         commit('SET_LOADING', true);

         return axios
            .get(PosDashboardAPIsConstants.API_PATH)
            .then(({ data }) => {
               commit('SET_DATA', data.result);
               return data;
            })
            .finally(() => commit('SET_LOADING', false));
      },
   },
};

export default PosDashboard;
